module.exports = __webpack_public_path__ + "img/active-bg-shadow.a967425.png";